<template>
    <div class="pop-wrapper" ref="popWrapper">
        <div class="pop-trigger" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave" @click="onClickTrigger">
            <slot></slot>
        </div>
        <teleport to="body">
            <div v-if="visible" class="pop-content" :class="placement" :style="popStyle"
                @mouseenter="onPopContentMouseEnter" @mouseleave="onPopContentMouseLeave" @click.stop>
                <div class="arrow"></div>
                <slot name="content"></slot>
            </div>
        </teleport>
    </div>
</template>

<script>
export default {
    name: "AhPop",
    props: {
        placement: {
            type: String,
            default: "bottom", // 默认方向为 bottom
            validator: (value) => ["top", "bottom", "left", "right"].includes(value),
        },
        trigger: {
            type: String,
            default: "hover", // 默认触发方式为 hover
            validator: (value) => ["hover", "click"].includes(value),
        },
    },
    data() {
        return {
            visible: false, // 控制弹出框是否显示
            triggerRect: null, // 触发按钮的位置信息
            hoverTimeout: null, // 用于延迟隐藏弹窗
        };
    },
    computed: {
        popStyle() {
            if (!this.triggerRect) return {};
            const { top, left, width, height } = this.triggerRect;

            switch (this.placement) {
                case "top":
                    return {
                        position: "fixed",
                        left: `${left + width / 2}px`,
                        top: `${top}px`,
                        transform: "translate(-50%, -100%)",
                    };
                case "bottom":
                    return {
                        position: "fixed",
                        left: `${left + width / 2}px`,
                        top: `${top + height}px`,
                        transform: "translate(-50%, 0)",
                    };
                case "left":
                    return {
                        position: "fixed",
                        left: `${left}px`,
                        top: `${top + height / 2}px`,
                        transform: "translate(-100%, -50%)",
                    };
                case "right":
                    return {
                        position: "fixed",
                        left: `${left + width}px`,
                        top: `${top + height / 2}px`,
                        transform: "translate(0, -50%)",
                    };
                default:
                    return {};
            }
        },
    },
    methods: {
        onMouseEnter() {
            if (this.trigger === "hover") {
                clearTimeout(this.hoverTimeout);
                this.triggerRect = this.$refs.popWrapper.getBoundingClientRect();
                this.visible = true;
            }
        },
        onMouseLeave() {
            if (this.trigger === "hover") {
                this.hoverTimeout = setTimeout(() => {
                    this.visible = false;
                }, 200); // 延迟 200ms 隐藏弹窗
            }
        },
        onPopContentMouseEnter() {
            if (this.trigger === "hover") {
                clearTimeout(this.hoverTimeout); // 取消隐藏计时器
            }
        },
        onPopContentMouseLeave() {
            if (this.trigger === "hover") {
                this.hoverTimeout = setTimeout(() => {
                    this.visible = false;
                }, 200); // 延迟 200ms 隐藏弹窗
            }
        },
        onClickTrigger() {
            if (this.trigger === "click") {
                this.triggerRect = this.$refs.popWrapper.getBoundingClientRect();
                this.visible = !this.visible;
            }
        },
        closePop(event) {
            if (this.trigger === "click" && !this.$refs.popWrapper.contains(event.target)) {
                this.visible = false;
            }
        },
    },
    mounted() {
        document.addEventListener("click", this.closePop);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.closePop);
        clearTimeout(this.hoverTimeout);
    },
};
</script>

<style lang="scss" scoped>
.pop-wrapper {
    position: relative;
    display: inline-block;
}

.pop-trigger {
    cursor: pointer;
}

.pop-content {
    background-color: #1a1a1d;
    color: #ffffff;
    border-radius: 4px;
    padding: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    z-index: 9999;
    min-width: 100px;
    text-align: center;
    position: relative;

    .arrow {
        position: absolute;
        width: 0;
        height: 0;
        border-style: solid;
    }

    &.top .arrow {
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
        border-width: 6px 6px 0 6px;
        border-color: #1a1a1d transparent transparent transparent;
    }

    &.bottom .arrow {
        top: -6px;
        left: 50%;
        transform: translateX(-50%);
        border-width: 0 6px 6px 6px;
        border-color: transparent transparent #1a1a1d transparent;
    }

    &.left .arrow {
        right: -6px;
        top: 50%;
        transform: translateY(-50%);
        border-width: 6px 0 6px 6px;
        border-color: transparent transparent transparent #1a1a1d;
    }

    &.right .arrow {
        left: -6px;
        top: 50%;
        transform: translateY(-50%);
        border-width: 6px 6px 6px 0;
        border-color: transparent #1a1a1d transparent transparent;
    }
}
</style>